import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ExternalLink, Phone } from 'lucide-react';
export function AgencyPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercentage = (scrollPosition + windowHeight) / documentHeight;
      if (scrollPercentage > 0.5 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasShown]);
  return <AnimatePresence data-id="element-11">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-50 md:w-[380px] bg-white shadow-2xl border border-neutral-200 rounded-2xl overflow-hidden" data-id="element-12">
          <div className="bg-neutral-100 px-6 py-4 flex justify-between items-center border-b border-neutral-200" data-id="element-13">
            <span className="font-semibold tracking-widest text-xs text-neutral-900 uppercase" data-id="element-14">
              Пропозиція для вас
            </span>
            <button onClick={() => setIsVisible(false)} className="text-neutral-400 hover:text-neutral-900 transition-colors" data-id="element-15">
              <X className="w-5 h-5" data-id="element-16" />
            </button>
          </div>

          <div className="p-6 md:p-8" data-id="element-17">
            <h3 className="text-xl md:text-2xl font-normal tracking-tight text-neutral-900 mb-4" data-id="element-18">
              Потрібен <span className="font-semibold" data-id="element-19">такий сайт?</span>
            </h3>
            <p className="text-neutral-600 mb-6 md:mb-8 font-normal leading-relaxed text-sm md:text-base" data-id="element-20">
              Цей сайт ми можемо зробити для вас повністю під ключ, адаптувати
              під всі ваші потреби та налаштувати для залучення клієнтів.
            </p>

            <div className="mb-6 md:mb-8 border-l-2 border-neutral-900 pl-4" data-id="element-21">
              <p className="text-xs md:text-sm text-neutral-500 uppercase tracking-widest mb-1 font-medium" data-id="element-22">
                Вартість під ключ
              </p>
              <p className="text-2xl md:text-3xl font-semibold text-neutral-900" data-id="element-23">
                8 000 грн
              </p>
            </div>

            <div className="space-y-3" data-id="element-24">
              <a href="tel:+380508399309" className="flex items-center justify-center gap-3 w-full py-3 md:py-4 px-4 bg-neutral-900 hover:bg-neutral-800 text-white font-medium transition-colors rounded-xl md:rounded-none" data-id="element-25">
                <Phone className="w-4 h-4" data-id="element-26" />
                +38 050 839 93 09
              </a>
              <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full py-3 md:py-4 px-4 bg-white border border-neutral-200 hover:bg-neutral-50 text-neutral-900 font-medium transition-colors rounded-xl md:rounded-none" data-id="element-27">
                <ExternalLink className="w-4 h-4" data-id="element-28" />
                jetly.agency/ua
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}